import NotificationsIcon from '@mui/icons-material/Notifications';

export const AlertIcon = NotificationsIcon;
